export default "__VITE_ASSET__DpIsgJDC__"